import { render } from "./CashRegistersView.vue?vue&type=template&id=a170126c"
import script from "./CashRegistersView.vue?vue&type=script&lang=js"
export * from "./CashRegistersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__